import { ServiceBase } from './../../../../core/services/ServiceBase'
import CompanyProfileProxy from './CompanyProfileProxy'

class CompanyProfileService extends ServiceBase {
  getCompanyHighlight(params) {
    return this.getData(() => CompanyProfileProxy.getCompanyHighlight(params))
  }

  getCompanyInfoDetail(params) {
    return this.getData(() => CompanyProfileProxy.getCompanyInfoDetail(params))
  }

  exportCompanyOverview(params) {
    return this.getFileDownload(() =>
      CompanyProfileProxy.exportCompanyOverview(params),
    )
  }

  exportIndustry(params) {
    return this.getFileDownload(() =>
      CompanyProfileProxy.exportIndustry(params),
    )
  }

  exportBoardOfDirector(params) {
    return this.getFileDownload(() =>
      CompanyProfileProxy.exportBoardOfDirector(params),
    )
  }

  exportBoardOfManagement(params) {
    return this.getFileDownload(() =>
      CompanyProfileProxy.exportBoardOfManagement(params),
    )
  }
}

export default new CompanyProfileService()
